import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { UserRolesComponent } from './user-roles.component';

export interface UserRolesProps extends FormlyFieldProps {
  maxDeviceManagers?: number;
  maxDataManagers?: number;
}

export interface FormlyUserRolesFieldConfig extends FormlyFieldConfig<UserRolesProps> {
  type: 'user-roles' | Type<FormlyUserRolesComponent>;
}

@Component({
  selector: 'vectronic-formly-user-roles-wrapper',
  imports: [UserRolesComponent, ReactiveFormsModule],
  template: `
    <section>
      @if (props.label) {
        <p class="main-label">{{ props.label }}</p>
      }
      <div class="content">
        <vectronic-formly-user-roles
          [formControl]="formControl"
          [id]="id"
          [maxDeviceManagers]="props.maxDeviceManagers ?? MAX_MANAGERS_COUNT"
          [maxDataManagers]="props.maxDataManagers ?? MAX_MANAGERS_COUNT"
        ></vectronic-formly-user-roles>
      </div>
    </section>
  `,
  styles: `
    @use 'variables';

    section {
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 1.5rem;
      padding-bottom: 0;
      margin-bottom: 1.25rem;
    }

    .main-label {
      font-size: 1rem;
      font-weight: 500;
      color: variables.$vectronic-blue;
      margin: 0 0 1.5rem;
      padding-bottom: 0.75rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
  `,
})
export class FormlyUserRolesComponent extends FieldType<FieldTypeConfig<UserRolesProps>> {
  protected readonly MAX_MANAGERS_COUNT: number = Infinity;
}
